import React from 'react';
import PropTypes from 'prop-types';
import SvgText from 'components/svg-text';
import styles from './index.css';

export default class TimeAxisTickLabel extends React.Component {
  static propTypes = {
    fontSize: PropTypes.number,
    text: PropTypes.string,
    textRef: PropTypes.func,
    x: PropTypes.number,
    y: PropTypes.number,
  };

  static defaultProps = {
    fontSize: 10,
    text: '',
    x: 0,
    y: 0,
  };

  render() {
    return (
      <SvgText
        className={styles.TimeAxisTickLabel}
        style={{
          fontSize: this.props.fontSize,
        }}
        text={this.props.text}
        textRef={this.props.textRef}
        x={this.props.x}
        y={this.props.y}
      />
    );
  }
}
